import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter, take } from 'rxjs/operators';

import { ICP } from '../../../state/icp/icp.state';
import * as IcpActions from '../../../state/icp/icp.actions';
import * as IcpSelectors from '../../../state/icp/icp.selectors';

@Component({
  selector: 'app-icp-detail',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './icp-detail.component.html',
  styleUrls: ['./icp-detail.component.scss']
})
export class IcpDetailComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private store = inject(Store);

  icp$: Observable<ICP | null> = this.store.select(IcpSelectors.selectSelectedIcp);
  loading$: Observable<boolean> = this.store.select(IcpSelectors.selectGetIcpDetailLoading);
  error$: Observable<string | null> = this.store.select(IcpSelectors.selectGetIcpDetailError);

  icpId: string | null = null;

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.icpId = params.get('id');
      if (this.icpId) {
        this.store.dispatch(IcpActions.getIcpDetail({ id: this.icpId }));
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onEdit(): void {
    if (this.icpId) {
      this.router.navigate(['/icp/edit', this.icpId]);
    }
  }

  onBack(): void {
    this.router.navigate(['/icp']);
  }

  getArrayDisplay(arr: any[]): string {
    if (!arr || !Array.isArray(arr) || arr.length === 0) {
      return 'N/A';
    }
    return arr.map(item => item.name || item).join(', ');
  }

  getDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (typeof value === 'object' && value.name) {
      return value.name;
    }
    return String(value);
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}